import { PencilPlusIcon } from './PencilPlusIcon';

/**
 * author: Michael Irigoyen
 * id F6194D2A-B09D-416D-98B9-C80FDA45D831
 * name pencil-plus
 * version: 3.5.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/pencil-plus.svg
 * tags
 */
export const PencilAddIcon = PencilPlusIcon;
export default PencilAddIcon